<template>
  <div class="slideshow">
    <div class="slideshow__container">
      <div ref="slider">
        <file ref="file" v-for="file in files" :data-url="file.url" :url="file.url" :key="file.url"></file>
      </div>
    </div>
    <button class="slideshow__button slideshow__button--previous" @click="previousSlide"></button>
    <button class="slideshow__button slideshow__button--next" @click="nextSlide"></button>
  </div>
</template>

<script>
import EventBus from '../util/EventBus'
import File from './File.vue'
import { tns } from 'tiny-slider/src/tiny-slider.module'

export default {
  name: 'slideshow',
  props: ['uid'],
  components: {
    'file': File
  },
  computed: {
    page () {
      return this.$store.getters.getPageByUID(this.uid)
    },
    files () {
      return this.page.files
    }
  },
  data () {
    return {
      slider: null,
    }
  },
  created () {
  },
  mounted () {
    let sliderOptions = {
      container: this.$refs.slider,
      items: 1,
      slideBy: 'page',
      loop: true,
      speed: 0,
      nav: false,
      mouseDrag: false,
      touch: false,
      controls: false,
      autoHeight: false,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayButtonOutput: false,
      // autoplayHoverPause: true,
      // autoplayDirection: 'forward'
    }

    try {
      this.slider = tns(sliderOptions)

      if (this.slider) {
        this.slider.events.on('transitionEnd', this.notifyChangeFile)
      }

    } catch (error) {
      // NB: we've gotten into some unrecoverable state, reload
      window.location.reload()
    }
  },
  destroyed () {
    if (this.slider) {
      this.slider.events.off('transitionEnd', this.notifyChangeFile)
    }
  },
  methods: {
    notifyChangeFile (info) {
      const currentSlide = info.slideItems[info.index]
      const file = this.findFileByUrl(currentSlide.getAttribute('data-url'))
      if (!file) {
        console.error('File not found! Current slide:', currentSlide)
        return
      }

      this.$emit('file-changed', file)
    },
    findFileByUrl (url) {
      let i = this.page.files.length
      while (i--) {
        if (this.page.files[i].url === url) {
          return this.page.files[i]
        }
      }

      return null
    },
    previousSlide () {
      if (!this.slider) {
        console.error('No slider to navigate')
        return
      }
      this.slider.goTo('prev')
    },
    nextSlide () {
      if (!this.slider) {
        console.error('No slider to navigate')
        return
      }
      this.slider.goTo('next')
    },
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';

.slideshow {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  height: var(--slideshow-height);
  width: 100%;
}

.slideshow img {
  display: block;
  height: 100%;
  width: 100%;
  object-fit: contain;
  object-position: left top;
}

.slideshow__container {
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  height: var(--slideshow-height);
}

.slideshow__container * {
  height: 100%;
  width: 100%;
}

.slideshow__button {
  grid-row: 1 / -1;
  position: relative;
  z-index: 10;
  border: 0;
  background: transparent;
  padding: 0;

  &:focus {
    outline: none;
  }
}

.slideshow__button--previous {
  grid-column: 1 / 2;
  cursor: w-resize;
}

.slideshow__button--next {
  grid-column: 2 / 3;
  cursor: e-resize;
}

.slideshow .tns-carousel {
  // height: calc(100vh - var(--line-height) * 3) !important;
}

// .project {
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;

//   &.project-slideable {
//     position: relative;
//   }
// }

// .landscape .project .tns-slide-active {
//   // NB: kill small line at certain screen sizes at right edge
//   // of landscape box
//   margin-right: 2px;
// }
</style>



// WEBPACK FOOTER //
// client/components/Slideshow.vue